import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Portfolio from './Portfolio';
import ResumePage from './components/ResumePage';
import './stylesheets/App.css';
import './stylesheets/Navbar.css';
import './stylesheets/Landing.css';
import './stylesheets/AboutMe.css';
// About me navroutes
import './stylesheets/AboutMeRoutes/AboutMeNavbar.css';
import './stylesheets/AboutMeRoutes/Bio.css';
import './stylesheets/AboutMeRoutes/Education.css';
import './stylesheets/AboutMeRoutes/Experience.css';
// Services
import './stylesheets/Services.css';
// portfolio
import './stylesheets/Portfolio.css';
// Testimonials
import './stylesheets/Testimonials.css';
// Blog
import './stylesheets/Blog.css';
// Contact me
import './stylesheets/ContactMe.css';
// Footer
import './stylesheets/Footer.css';
// Resume page styles
import './stylesheets/Resume.css';
// font awesome
import '../node_modules/font-awesome/css/font-awesome.min.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <HelmetProvider>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Portfolio />} />
        <Route path="/resume" element={<ResumePage />} />
      </Routes>
    </BrowserRouter>
  </HelmetProvider>,
);
